<template>
  <div>
    <el-select v-model="areaIds[0]" :disabled="dis[0]" clearable @change="remoteMethod($event,1)" placeholder="省">
      <el-option
        v-for="(o,i) in area_option_data.province"
        :key="i"
        :label="o.name"
        :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
    <el-select v-model="areaIds[1]" :disabled="dis[1]" clearable @change="remoteMethod($event,2)" placeholder="市" style="margin-left: 20px;">
      <el-option
        v-for="(o,i) in area_option_data.city"
        :key="i"
        :label="o.name"
        :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
    <el-select v-model="areaIds[2]" :disabled="dis[2]" clearable @change="remoteMethod($event,3)" placeholder="区、县" style="margin-left: 20px;">
      <el-option
        v-for="(o,i) in area_option_data.county"
        :key="i"
        :label="o.name"
        :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
    <br />
    <el-select v-model="areaIds[3]" :disabled="dis[3]" clearable @change="remoteMethod($event,4)" placeholder="乡、镇" style="margin-top: 10px;">
      <el-option
        v-for="(o,i) in area_option_data.town"
        :key="i"
        :label="o.name"
        :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
    <el-select v-model="areaIds[4]" :disabled="dis[4]" clearable @change="remoteMethod($event,5)" placeholder="街道、村" style="margin: 10px 0 0 20px">
      <el-option
        v-for="(o,i) in area_option_data.village"
        :key="i"
        :label="o.name"
        :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    area_option_data: Object,
    // arr: Array,
    dis: Array
  },
  data() {
    return {
      areaIds: ['', '', '', '', ''],
    }
  },
  created() {},
  methods: {
    //选择某项时获取下一项的地点数据
    remoteMethod(value, num) {
			let areaName = [];
			let { areaIds } = this
      switch (num) {
        case 1:
          areaIds[1] = areaIds[2] = areaIds[3] = areaIds[4] = '';
          areaName[num - 1] = this.getName(value, this.area_option_data.province);
          break;
        case 2:
          areaIds[2] = areaIds[3] = areaIds[4] = '';
          areaName[num - 1] = this.getName(value, this.area_option_data.city);
          break;
        case 3:
          areaIds[3] = areaIds[4] = '';
          areaName[num - 1] = this.getName(value, this.area_option_data.county);
          break;
        case 4:
          areaIds[4] = '';
          areaName[num - 1] = this.getName(value, this.area_option_data.town);
          break;
        case 5:
          areaName[num - 1] = this.getName(value, this.area_option_data.village);
          break;
      }
      this.$emit("getFilterArea", {
        value: { areaId: value },
        key: num,
        name: areaName[num - 1]
      })
    },
    //获取id对应name
    getName(id, arr) {
      let a = ''
      for (let i = 0; i in arr; i++) {
        const o = arr[i]
        if (o.id == id) {
          a = o.name
        }
      }
      return a
    }
  },
  // watch: {
  //   arr(value) {
  //     this.areaIds = this.arr;
  //   },
  //   immediate: true, //关键
  //   deep: true
  // }
};
</script>
